/*
const partialCircle = (cx, cy, r, start, end) => {
	const length = end - start
	if (length === 0) return []

	const fromX = r * Math.cos(start) + cx
	const fromY = r * Math.sin(start) + cy
	const toX = r * Math.cos(end) + cx
	const toY = r * Math.sin(end) + cy
	const large = Math.abs(length) <= Math.PI ? '0' : '1'
	const sweep = length < 0 ? '0' : '1'

	return [
		['M', fromX, fromY],
		['A', r, r, 0, large, sweep, toX, toY]
	]
}
*/

// degrees to radians
function rad(degrees) {
	return ((degrees - 180) * (Math.PI / 180));
}

function donut(cx, cy, ri, ro, ds, de) { // center x, center y, inner radius, outer radius, degree start, degree end

	// if (de === 360) de = 359.9999; // hotfix for full cirlce

	// intermediate step needed?
	var di = (de-ds >= 360) ? [rad(((de-ds)/3)+ds), rad(((de-ds)*(2/3))+ds)] : (de-ds >= 180) ? [rad(((de-ds)/2)+ds)] : [];

	// convert degrees to radians
	ds = rad(ds);
	de = rad(de);
	
	var result = [];
	
	// move to first corner
	result.push([ "M", (ri * Math.cos(ds) + cx), (ri * Math.sin(ds) + cy) ].join(" "));

	// arc to intermediate corner
	di.forEach(function(dii){
		result.push([ "A", ri, ri, 0, 0, 1, (ri * Math.cos(dii) + cx), (ri * Math.sin((dii)) + cy) ].join(" "));
	}); 
		
	// arc to second corner
	result.push([ "A", ri, ri, 0, 0, 1, (ri * Math.cos(de) + cx), (ri * Math.sin(de) + cy) ].join(" "));
	
	// line to third corner
	result.push([ "L", (ro * Math.cos(de) + cx), (ro * Math.sin(de) + cy) ].join(" "));

	// arc to intermediate corner
	di.reverse().forEach(function(dii){
		result.push([ "A", ro, ro, 0, 0, 0, (ro * Math.cos((dii)) + cx), (ro * Math.sin((dii)) + cy) ].join(" "));
	});

	// arc to fourth corner
	result.push([ "A", ro, ro, 0, 0, 0, (ro * Math.cos(ds) + cx), (ro * Math.sin(ds) + cy) ].join(" "));
	
	// line to first corner
	result.push([ "L", (ri * Math.cos(ds) + cx), (ri * Math.sin(ds) + cy) ].join(" "));
		
	return result.join(" ");
};

function area(ri, ro, p){ // inner radius, outer radius, percentage

	// i hope this is right
	return Math.sqrt(((((ro*ro*Math.PI)-(ri*ri*Math.PI))*p)+(ri*ri*Math.PI))/Math.PI);

	var ai = (ri*ri*Math.PI); // area of hole
	var ao = (ro*ro*Math.PI); // area of border
	var ac = ((ao-ai)*p); // area of inner segment
	var rc = Math.sqrt((ac + ai) / Math.PI); // radius of inner segment
	
	return rc;
	
};

export default donut;


/*
console.log('<?xml version="1.0" encoding="UTF-8" standalone="no"?>');
console.log('<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.0//EN" "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">');
console.log('<svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" version="1.0" width="500" height="500" viewBox="0 0 500 500">');
console.log('	<g stroke="#000" stroke-width="0.1">');

console.log('		<path d="'+donut(200, 200, 50, 100, 0, 45)+'" fill="#f00" />');
console.log('		<path d="'+donut(200, 200, 100, 150, 0, 45)+'" fill="#c00" />');

console.log('		<path d="'+donut(200, 200, 50, 100, 45, 100)+'" fill="#ff0" />');
console.log('		<path d="'+donut(200, 200, 50, 100, 100, 180)+'" fill="#0f0" />');
console.log('		<path d="'+donut(200, 200, 50, 100, 180, 359)+'" fill="#0ff" />');
console.log('		<path d="'+donut(200, 200, 50, 100, 359, 360)+'" fill="#00f" />');

console.log('	</g>');
console.log('</svg>');
*/


